module.exports = __webpack_public_path__ + "img/Lille.0e08c3b4.png";